// Group by Team
export const ROLLOUTS = {
    // Hawks
    HAWKS_NEW_MIDDLEWARE_FLOW: 'hawks_new_middleware_flow',
    HAWKS_AI_STORE_BUILDER_ENTRY_POINTS: 'hawks_ai_store_builder_entry_points',

    // Crows
    CROWS_EXACT_MATCH_FREELANCER_SEARCH_REDIRECT: 'crows_exact_match_freelancer_search_redirect',
    CROWS_PRO_CATALOG_NO_RESULTS: 'crows_pro_catalog_no_results_rollout',
    CROWS_AI_DIRECTOR_BANNER: 'crows_ai_director_banner',
    CROWS_MP_BFF_EXPANSION: 'crows_mp_bff_expansion',

    // TODO Group By Team and cleanup
    VIPERS_BRIEF_AND_MATCH_MODAL: 'vipers_brief_and_match_modal',
    MUSTANGS_CUSTOM_DEFAULT_FILTERS: 'mustangs_custom_default_filters',
    HAWKS_LISTINGS_SIDE_FILTERS: 'hawks_listings_side_filters',
    CARIBOU_RATING_SCORE_UPDATES: 'caribou_rating_score_updates',
    // cheetahs
    CHEETAHS_BOOK_PUBLISHING: 'cheetahs_book_publishing',
    CHEETAHS_BOOK_PUBLISHING_ALLOCATION_GUARD: 'cheetahs_book_publishing_allocation_guard',

    // dolphins
    DOLPHINS_HOURLY_RATE_BANNER_LISTINGS_GUEST: 'dolphins_hourly_rate_banner_listings_guest',

    // meerkats
    MEERKATS_LISTINGS_RELATED_SKILLS: 'meerkats_listings_related_skills',
    MEERKATS_LISTINGS_AGGREGATE_RATING: 'meerkats_listings_aggregate_rating',
    MEERKATS_PRO_SKILLS_CATALOG: 'meerkats_pro_skills_catalog',

    // piglets
    PIGLETS_ENABLE_PRICE_UPFRONT: 'piglets_enable_price_upfront_display',

    // panthers
    PANTHERS_REMOVE_PA_FILTER_TEST: 'panthers_remove_pa_filter_test',
};
